var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-btn",class:{ active: _vm.isChoose },on:{"mouseenter":_vm.choose}},[_c('div',{staticClass:"icon"},[_c('i',{class:'iconfont ' + _vm.icon})]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }